<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i>
        <strong>Liste des profils</strong>
      </b-card-header>
      <b-card-body>
        <v-client-table :columns="columns" :data="items" :options="options" ref="profil-table">
          <div slot="action" slot-scope="props">
            <i v-b-tooltip.hover title="Modifier le profil" class="fa fa-edit fa-1_5x text-primary clickable" @click="editProfil('edit', props.row.id)"></i>
            <i v-b-tooltip.hover title="Supprimer le profil" @click="destroy(props.row.id)" class="text-danger ml-2 fa fa-trash clickable"></i>
          </div>
          <div v-if="props.row.structure" slot="structure" slot-scope="props" class="">
            <b-badge class="mr-1" v-for="structure in props.row.structures" variant="success" :key="structure.id">{{ structure.libelle }}</b-badge>
          </div>
          <div v-if="props.row.traitements" slot="traitements" slot-scope="props" class="">
            <b-badge class="mr-1" v-for="traitement in props.row.traitements" variant="info" :key="traitement.id">{{ traitement.libelle }}</b-badge>
          </div>
          <div v-if="props.row.oags" slot="oags" slot-scope="props" class="">
            <b-badge class="mr-1" v-for="oag in props.row.oags" variant="warning" :key="oag.id">{{ oag.code }}</b-badge>
          </div>
          <div v-if="props.row.oaps" slot="oaps" slot-scope="props" class="">
            <b-badge class="mr-1" v-for="oap in props.row.oaps" variant="warning" :key="oap.id">
              <span v-b-tooltip.hover :title="oap.libelle">{{ oap.code }}</span>
            </b-badge>
          </div>
          <div v-if="props.row.types_dossier" slot="typeDossier" slot-scope="props" class="">
            <b-badge class="mr-1" v-for="type in props.row.types_dossier" variant="warning" :key="type.id">{{ type.libelle_court }}</b-badge>
          </div>
          <div v-if="props.row.created_at" slot="created_at" slot-scope="props" class="slot-date">
            <span class="badge badge-success p-2">{{ formatDate(props.row.created_at) }}</span>
          </div>
        </v-client-table>
      </b-card-body>
      <div slot="footer">
        <b-button
          type="button"
          @click="editProfil('add')"
          class="pull-right"
          size="md"
          variant="primary"
        >
          <i class="fa fa-plus"></i> Ajouter un profil
        </b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from "@/utils/auth";

export default {
  data() {
    return {
      columns: ['created_at', 'libelle', 'code', 'traitements', 'oags', 'oaps', 'typeDossier', 'structure', 'action'],
      items: [],
      options: {
        headings: {
          libelle: 'Libellé',
          code: 'Code',
          structure: 'Structure',
          traitements: 'Traitements',
          oags: 'OAG',
          oaps: 'OAP',
          typeDossier: 'Type dossier visible',
          created_at: 'Créé le'
        },
        columnsClasses: {
          action: 'action-xs'
        },
        sortable: ['libelle'],
        filterable: ['libelle', 'code'],
        // initFilters: {},
        perPage: 10,
        perPageValues: [10, 20, 25],
        texts: { filterPlaceholder: 'Libellé, Code' },
        orderBy: { column: 'created_at', ascending: false },
      },
      libelle: '',
      code: '',
      structure: '',
      droitsOptions: [],
      droitSelected: [],
      checkedDroits: [],
      errors: {
        libelle: '',
        code: '',
        structure: '',
        profilId: ''
      }
    };
  },
  mounted() {
    this.all();
    this.allHabilitations();

    // On remet en place le filtre s'il y en avait un
    if (this.$route.query.filter) {
      this.$refs['profil-table'].setFilter(this.$route.query.filter);
    }
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
    this.$axios.defaults.headers.common["Accept"] = "application/json";
    this.$axios.defaults.headers.common["Provider"] = getProvider();
  },
  methods: {
    all() {
      let self = this;
      this.$axios
        .get("/administration/profiles")
        .then(response => {
          this.items = response.data.profils;
        })
        .catch(function(error) {
          self.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: "Un probléme est survenu, merci de contacter l'administrateur",
            showConfirmButton: false,
            timer: 5000
          });
        });
    },
    destroy(id) {
      const self = this;
      this.$swal
        .fire({
          title: "Êtes-vous sûr?",
          text: "Voulez-vous vraiment supprimer ce profil ?",
          type: "warning",
          reverseButtons: true,
          showCancelButton: true,
          cancelButtonColor: "#ff1744",
          confirmButtonText: "Annuler",
          cancelButtonText: "Supprimer"
        })
        .then(result => {
          if (!result.value) {
            this.$store.commit("IS_LOADING", true);
            this.$axios
              .post("/administration/profiles/delete/" + id)
              .then(response => {
                this.$store.commit("IS_LOADING", false);
                this.$swal({
                  position: "top",
                  type: "success",
                  title: "Suppression avec succès",
                  text: "Le profil a bien été supprimé",
                  showConfirmButton: false,
                  timer: 5000
                });
                this.all();
              })
              .catch(function(error) {
                self.$store.commit("IS_LOADING", false);
                if (error.response && self !== undefined && error.response.status === 403) {
                  self.$swal({
                    position: "top",
                    type: "warning",
                    title: "Attention !!",
                    text: "Vous ne pouvez pas supprimer ce profil car il est encore rattaché à au moins un utilisateur.",
                    showConfirmButton: false,
                    timer: 5000
                  });
                  
                }else{
                  self.$swal({
                    position: "top",
                    type: "warning",
                    title: "Attention !!",
                    text: "Un probléme est survenu, merci de contacter l'administrateur",
                    showConfirmButton: false,
                    timer: 5000
                  });
                }
              });
          }
        });
    },
    editProfil(to, id) {
      if (to === "edit") {
        this.$router.push({ path: "/administration/profiles/edit/" + id, query: {filter: this.$refs['profil-table'].q} });
      } else if (to === "add") {
        this.$router.push({ path: "/administration/profiles/add", query: {filter: this.$refs['profil-table'].q} });
      }
    },
    allHabilitations() {
      // Récupérer la liste de tous les droits
      this.$axios
        .get("/administration/droits")
        .then(response => {
          let droits = response.data.droits;

          for (var i = 0; i < droits.length; i++) {
            this.droitsOptions.push({
              id: droits[i].id,
              text: droits[i].libelle,
              value: droits[i].libelle_technique,
              domaine: droits[i].domaine,
              category: droits[i].categorie
            });
          }
        })
        .catch(function(error) {});
    },
    clearProfil() {
      this.droitSelected = []
      this.checkedDroits = []
    },
    saveProfil(id) {
      if (this.validateData()) {
        this.$store.commit("IS_LOADING", true);
        let self = this;
        let dataPost = {};
        let profilId = id;

        dataPost.libelle = this.libelle;
        dataPost.code = this.code;
        dataPost.structure = this.structure;
        dataPost.droits = this.checkedDroits;

        this.$axios
          .put("/administration/profiles/" + profilId, dataPost)
          .then(response => {
            this.$store.commit("IS_LOADING", false);
            this.$swal({
              position: "top",
              type: "success",
              title: "Modification avec succès",
              text: "Le profil " + dataPost.libelle +  " a bien été modifié",
              showConfirmButton: false,
              timer: 5000
            });
            // this.returnBack()
            this.$refs['modal-profil'].hide()
            // TODO : modifier la ligne dans le tableau de résultat
            for(let v = 0; v < this.items.length; v++) {
              if (this.items[v].id == this.profilId) {
                this.items[v].libelle = dataPost.libelle
                this.items[v].code = dataPost.code
                this.items[v].structure = dataPost.structure
              }
              // console.log(this.items[v])
            }
          })
          .catch(function(error) {
            console.log(error)
            self.$store.commit("IS_LOADING", false);
            self.$swal({
              position: "top",
              type: "error",
              title: "Attention !!",
              text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
              showConfirmButton: false,
              timer: 5000
            });
          });
      }
    },
    validateData() {
      this.clearErrors();
      let regAlphaDash = this.$store.getters.getRegAlphaDash
      let regAlphaNumeric = this.$store.getters.getRegAlphaNumeric
      let valid = true

      if (this.libelle === "") {
        this.errors.libelle = "Le libellé est obligatoire";
        valid = false;
      }
      // else if (!regAlphaDash.test(this.libelle.trim())) {
      //   valid = false
      //   this.errors.libelle  = 'Veuillez entrer un libellé valide'
      // }

      if (this.code === "") {
        this.errors.code = "Le code est obligatoire";
        valid = false;
      }
      // else if (!regAlphaNumeric.test(this.code.trim())) {
      //   valid = false
      //   this.errors.code  = 'Veuillez entrer un code valide'
      // }
      if (this.structure === "") {
        this.errors.structure = "La structure est obligatoire";
        valid = false;
      }
      return valid;
    },
    returnBack() {
      this.$router.push({ path: "/administration/profiles" });
    },
    clearErrors() {
      this.errors.libelle = "";
      this.errors.code = "";
    },
    formatDate(textDate) {
      let date =
        textDate !== null
          ? new Date(textDate).toLocaleDateString("fr-FR")
          : "-";
      return date;
    }
  }
};
</script>
